export default __webpack_public_path__ + "static/media/diver.88c4bc12.svg";